import { createContext, Dispatch, SetStateAction } from "react";
import { Stripe } from '@stripe/stripe-js';
import { Product, Purchase, Subscription, UserDiscount } from "referral-types";
import { KeyedMutator } from "swr";


type PurchaseContextType = {
    isSubscribing?: boolean;
    toggleSubscribing: () => void;
    isCheckingOut?: boolean;
    setIsCheckingOut: Dispatch<SetStateAction<boolean | undefined>>;

    isRefreshingToken?: boolean;

    completedPurchase: Purchase | undefined,
    setCompletedPurchase: Dispatch<SetStateAction<Purchase | undefined>>,
    completedSubscription: Subscription | undefined,
    setCompletedSubscription: Dispatch<SetStateAction<Subscription | undefined>>,

    stripePromise: Stripe | null;

    cart: Array<Product>;
    toggleProduct: (product: Product) => void;
    clearCart: () => void;

    toggleUnlimtedReferralCart: () => void;
    isUnlimitedReferralCartToggled?: boolean;
    unlimitedReferralProduct?: Product;

    userDiscounts?: Array<UserDiscount>;
    userDiscountMutator: KeyedMutator<Array<UserDiscount>>;
    
    userSubscriptions?: Array<Subscription>;
    userSubscriptionsMutator: KeyedMutator<Array<Subscription>>;

    isPurchasingProducts?: boolean;
    setIsPurchasingProducts: Dispatch<SetStateAction<boolean | undefined>>;
};

export const PurchaseContext = createContext<PurchaseContextType | undefined>(undefined);
